import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';
import * as PDFLib from 'pdf-lib';


(pdfjsLib as any).GlobalWorkerOptions.workerSrc =
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

const { PDFDocument, rgb } = PDFLib;


@Component({
  selector: 'app-view-pdf',
  templateUrl: './view-pdf.component.html',
  styleUrl: './view-pdf.component.scss'
})
export class ViewPdfComponent implements OnInit, AfterViewInit {

  @Input() documentData: any = {};
  @Output() close = new EventEmitter<void>();

  private PDF_URL = '';
  private SCALE = 1.3;

  private pdfDoc: any;
  private viewer!: HTMLElement;
  private loadingEl!: HTMLElement | null;

  private allSignatureData: any[] = [];

  formattedSignersJson: string = '';

  constructor() { }

  ngOnInit(): void {
    this.PDF_URL = this.documentData?.pdfUrl;

    const signatureData = this.documentData?.allSignersPositions || [];
    if (signatureData[0]?.signatureData) {
      this.allSignatureData = signatureData.flatMap(
        (signer: any) => signer.signatureData || []
      );
    } else if (signatureData[0]?.coordinates) {
      this.allSignatureData = signatureData;
    }

    this.formattedSignersJson = JSON.stringify(
      signatureData,
      null,
      2
    );
  }

  ngAfterViewInit(): void {
    this.viewer = document.getElementById('viewer') as HTMLElement;
    this.loadingEl = document.getElementById('loading');
    this.generatePreviewPdf();
  }

  async generatePreviewPdf() {
    const existingPdfBytes = await fetch(this.PDF_URL).then(r =>
      r.arrayBuffer()
    );

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const pages = pdfDoc.getPages();

    // Draw signature boxes into REAL PDF
    this.allSignatureData.forEach(p => {
      const pageIndex = Number(p.page) - 1;
      const page = pages[pageIndex];
      if (!page) return;

      const pageHeight = page.getHeight();

      p.coordinates.forEach((c, i) => {
        const pdfX = c.x;
        const pdfY = pageHeight - c.y - c.h * 1.2;

        page.drawRectangle({
          x: pdfX,
          y: pdfY,
          width: c.w,
          height: c.h,
          borderWidth: 0.8,
          borderColor: rgb(0.85, 0.85, 0.85)
        });

        const fontSize = 9;
        const text = `Sign here`;

        page.drawText(text, {
          x: pdfX + 10,
          y: pdfY + c.h / 2 - fontSize / 2,
          size: fontSize,
          color: rgb(0.75, 0.75, 0.75)
        });
      });

    });

    const updatedPdfBytes = await pdfDoc.save();

    const uint8 = updatedPdfBytes instanceof Uint8Array
      ? updatedPdfBytes
      : new Uint8Array(updatedPdfBytes);

    const buffer = new ArrayBuffer(uint8.byteLength);
    new Uint8Array(buffer).set(uint8);

    const blob = new Blob([buffer], { type: 'application/pdf' });
    this.PDF_URL = URL.createObjectURL(blob);
    this.loadPdf();
  }

  async loadPdf(): Promise<void> {
    try {
      const loadingTask = pdfjsLib.getDocument({ url: this.PDF_URL });
      this.pdfDoc = await loadingTask.promise;

      this.loadingEl?.remove();

      for (let p = 1; p <= this.pdfDoc.numPages; p++) {
        await this.renderPage(p);
      }
    } catch (err) {
      if (this.loadingEl) {
        this.loadingEl.textContent = 'Failed to load PDF';
      }
      console.error(err);
    }
  }

  async renderPage(pageNum: number): Promise<void> {
    const page = await this.pdfDoc.getPage(pageNum);
    const viewport = page.getViewport({ scale: this.SCALE });

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;

    canvas.width = viewport.width;
    canvas.height = viewport.height;
    canvas.style.width = '100%';
    canvas.style.display = 'block';
    canvas.style.marginBottom = '16px';
    canvas.style.borderRadius = '6px';
    canvas.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';

    await page.render({ canvasContext: ctx, viewport }).promise;

    this.viewer.appendChild(canvas);
  }


  exitDoc(): void {
    this.close.emit();
  }

  copySuccess = false;
  showJSON: boolean = false;
  getJson() {
    this.showJSON = !this.showJSON;
  }

  copySignersJson() {
    navigator.clipboard.writeText(this.formattedSignersJson);
    this.copySuccess = true;

    setTimeout(() => {
      this.copySuccess = false;
    }, 1500);
  }
}